export default __webpack_public_path__ + "static/media/sofa.9d3f457e.svg";